import { ModuleWithProviders, NgModule } from '@angular/core';
import { SharedModule } from 'primeng/api';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DataService } from './data/data.service';
import { JobService } from './job/job.service';
import { AuthDataService } from './auth/auth-data.service';
import { MessagesService } from './messages/messages.service';
import { RouterModule } from '@angular/router';
import { LinkUnlinkService } from './linkUnlink/linkUnlink.service';
import { BenefitsService } from './benefits/benefits.service';
import { SearchPlanService } from './searchPlan/searchPlanService.service';
import { PaymentService } from './payment/payment.service';
import { ProfileService } from '../components/pages/profile/profile.service';
import { ServiceRequestService } from './service-request/service-request.service';
import { LiferayService } from './liferay/liferay.service';
import { PazeService } from './paze/paze.service';
import { UtilitiesService } from './utilities/utilities.service';
import { EnrollmentService } from './enrollment/enrollment.service';


@NgModule({
  imports: [RouterModule.forRoot([])],
})
export class ServicesModule {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [
        provideHttpClient(withInterceptorsFromDi()),
        AuthDataService,
        DataService,
        JobService,
        MessagesService,
        BenefitsService,
        Window,
        LinkUnlinkService,
        SearchPlanService,
        PaymentService,
        ProfileService,
        ServiceRequestService,
        EnrollmentService,
      ]
    }
  }
}
